const spellsLVL8 = [
  {
    index: 'animal-shapes',
    name: 'Animal Shapes',
    url: '/api/spells/animal-shapes',
    shortdesc:
      'Transforms any number of creatures into large or smaller animals',
    desc: [
      'Your magic turns others into beasts. Choose any number of willing creatures that you can see within range. You transform each target into the form of a Large or smaller beast with a challenge rating of 4 or lower. On subsequent turns, you can use your action to transform affected creatures into new forms.',
      "The transformation lasts for the duration for each target, or until the target drops to 0 hit points or dies. You can choose a different form for each target. A target's game statistics are replaced by the statistics of the chosen beast, though the target retains its alignment and Intelligence, Wisdom, and Charisma scores. The target assumes the hit points of its new form, and when it reverts to its normal form, it returns to the number of hit points it had before it transformed. If it reverts as a result of dropping to 0 hit points, any excess damage carries over to its normal form. As long as the excess damage doesn't reduce the creature's normal form to 0 hit points, it isn't knocked unconscious. The creature is limited in the actions it can perform by the nature of its new form, and it can't speak or cast spells.",
      "The target's gear melds into the new form. The target can't activate, wield, or otherwise benefit from any of its equipment.",
    ],
    range: '30 feet',
    components: ['V', 'S'],
    ritual: false,
    duration: 'Up to 24 hours',
    concentration: true,
    casting_time: '1 action',
    level: 8,
  },
  {
    index: 'antipathy-sympathy',
    name: 'Antipathy/ Sympathy',
    url: '/api/spells/antipathy-sympathy',
    shortdesc:
      'Either repels or attracts a creature of your choice with a failed Wis save.',
    desc: [
      "This spell attracts or repels creatures of your choice. You target something within range, either a Huge or smaller object or creature or an area that is no larger than a 200-foot cube. Then specify a kind of intelligent creature, such as red dragons, goblins, or vampires. You invest the target with an aura that either attracts or repels the specified creatures for the duration. Choose antipathy or sympathy as the aura's effect.",
      'Antipathy.',
      "The enchantment causes creatures of the kind you designated to feel an intense urge to leave the area and avoid the target. When such a creature can see the target or comes within 60 feet of it, the creature must succeed on a wisdom saving throw or become frightened. The creature remains frightened while it can see the target or is within 60 feet of it. While frightened by the target, the creature must use its movement to move to the nearest safe spot from which it can't see the target. If the creature moves more than 60 feet from the target and can't see it, the creature is no longer frightened, but the creature becomes frightened again if it regains sight of the target or moves within 60 feet of it.",
      'Sympathy.',
      "The enchantment causes the specified creatures to feel an intense urge to approach the target while within 60 feet of it or able to see it. When such a creature can see the target or comes within 60 feet of it, the creature must succeed on a wisdom saving throw or use its movement on each of its turns to enter the area or move within reach of the target. When the creature has done so, it can't willingly move away from the target. If the target damages or otherwise harms an affected creature, the affected creature can make a wisdom saving throw to end the effect, as described below.",
      'Ending the Effect.',
      'If an affected creature ends its turn while not within 60 feet of the target or able to see it, the creature makes a wisdom saving throw. On a successful save, the creature is no longer affected by the target and recognizes the feeling of repugnance or attraction as magical. In addition, a creature affected by the spell is allowed another wisdom saving throw every 24 hours while the spell persists.',
      'A creature that successfully saves against this effect is immune to it for 1 minute, after which time it can be affected again.',
    ],
    range: '60 feet',
    components: ['V', 'S', 'M'],
    material:
      'Either a lump of alum soaked in vinegar for the antipathy effect or a drop of honey for the sympathy effect.',
    ritual: false,
    duration: '10 days',
    concentration: false,
    casting_time: '1 hour',
    level: 8,
    area_of_effect: {
      type: 'cube',
      size: 200,
    },
  },
  {
    index: 'control-weather',
    name: 'Control Weather',
    url: '/api/spells/control-weather',
    shortdesc: 'You take control of the weather within 5 miles of you.',
    desc: [
      "You take control of the weather within 5 miles of you for the duration. You must be outdoors to cast this spell. Moving to a place where you don't have a clear path to the sky ends the spell early.",
      'When you cast the spell, you change the current weather conditions, which are determined by the DM based on the climate and season. You can change precipitation, temperature, and wind. It takes 1d4 × 10 minutes for the new conditions to take effect. Once they do so, you can change the conditions again. When the spell ends, the weather gradually returns to normal.',
      'When you change the weather conditions, find a current condition on the following tables and change its stage by one, up or down. When changing the wind, you can change its direction.',
    ],
    range: 'Self',
    components: ['V', 'S', 'M'],
    material: 'Burning incense and bits of earth and wood mixed in water.',
    ritual: false,
    duration: 'Up to 8 hours',
    concentration: true,
    casting_time: '10 minutes',
    level: 8,
  },
  {
    index: 'earthquake',
    name: 'Earthquake',
    url: '/api/spells/earthquake',
    shortdesc:
      'Create a 100 ft radius earthquake that creates fissures and destroys most buildings.',
    desc: [
      'You create a seismic disturbance at a point on the ground that you can see within range. For the duration, an intense tremor rips through the ground in a 100-foot-radius circle centered on that point and shakes creatures and structures in contact with the ground in that area.',
      "The ground in the area becomes difficult terrain. Each creature on the ground that is concentrating must make a constitution saving throw. On a failed save, the creature's concentration is broken.",
      'When you cast this spell and at the end of each turn you spend concentrating on it, each creature on the ground in the area must make a dexterity saving throw. On a failed save, the creature is knocked prone.',
      'This spell can have additional effects depending on the terrain in the area, as determined by the DM.',
      "Fissures. Fissures open throughout the spell's area at the start of your next turn after you cast the spell. A total of 1d6 such fissures open in locations chosen by the DM. Each is 1d10 × 10 feet deep, 10 feet wide, and extends from one edge of the spell's area to the opposite side. A creature standing on a spot where a fissure opens must succeed on a dexterity saving throw or fall in. A creature that successfully saves moves with the fissure's edge as it opens.",
      'A fissure that opens beneath a structure causes it to automatically collapse (see below).',
      "Structures. The tremor deals 50 bludgeoning damage to any structure in contact with the ground in the area when you cast the spell and at the start of each of your turns until the spell ends. If a structure drops to 0 hit points, it collapses and potentially damages nearby creatures. A creature within half the distance of a structure's height must make a dexterity saving throw. On a failed save, the creature takes 5d6 bludgeoning damage, is knocked prone, and is buried in the rubble, requiring a DC 20 Strength (Athletics) check as an action to escape. The DM can adjust the DC higher or lower, depending on the nature of the rubble. On a successful save, the creature takes half as much damage and doesn't fall prone or become buried.",
    ],
    range: '500 feet',
    components: ['V', 'S', 'M'],
    material: 'A pinch of dirt, a piece of rock, and a lump of clay.',
    ritual: false,
    duration: 'Up to 1 minute',
    concentration: true,
    casting_time: '1 action',
    level: 8,
    area_of_effect: {
      type: 'sphere',
      size: 100,
    },
  },
  {
    index: 'feeblemind',
    name: 'Feeblemind',
    url: '/api/spells/feeblemind',
    shortdesc: 'You blast the mind of a creature that you can see within range',
    desc: [
      'You blast the mind of a creature that you can see within range, attempting to shatter its intellect and personality. The target takes 4d6 psychic damage and must make an intelligence saving throw.',
      "On a failed save, the creature's Intelligence and Charisma scores become 1. The creature can't cast spells, activate magic items, understand language, or communicate in any intelligible way. The creature can, however, identify its friends, follow them, and even protect them.",
      'At the end of every 30 days, the creature can repeat its saving throw against this spell. If it succeeds on its saving throw, the spell ends.',
      'The spell can also be ended by greater restoration, heal, or wish.',
    ],
    range: '150 feet',
    components: ['V', 'S', 'M'],
    material: 'A handful of clay, crystal, glass, or mineral spheres.',
    ritual: false,
    duration: 'Instantaneous',
    concentration: false,
    casting_time: '1 action',
    level: 8,
    damage: {
      damage_type: {
        index: 'psychic',
        name: 'Psychic',
        url: '/api/damage-types/psychic',
      },
      damage_at_slot_level: {
        8: '4d6',
      },
    },
    dc: {
      dc_type: {
        index: 'int',
        name: 'INT',
        url: '/api/ability-scores/int',
      },
      dc_success: 'other',
      desc: "The target always takes the damage. On a failed save, the creature's Intelligence and Charisma scores become 1.",
    },
  },
  {
    index: 'sunburst',
    name: 'Sunburst',
    url: '/api/spells/sunburst',
    shortdesc:
      '60 ft radius of sunlight deals 12d6 radiant damage and blinds targets for 1 minute. ',
    desc: [
      "Brilliant sunlight flashes in a 60-foot radius centered on a point you choose within range. Each creature in that light must make a constitution saving throw. On a failed save, a creature takes 12d6 radiant damage and is blinded for 1 minute. On a successful save, it takes half as much damage and isn't blinded by this spell. Undead and oozes have disadvantage on this saving throw.",
      'A creature blinded by this spell makes another constitution saving throw at the end of each of its turns. On a successful save, it is no longer blinded.',
      'This spell dispels any darkness in its area that was created by a spell.',
    ],
    range: '150 feet',
    components: ['V', 'S', 'M'],
    material: 'Fire and a piece of sunstone.',
    ritual: false,
    duration: 'Instantaneous',
    concentration: false,
    casting_time: '1 action',
    level: 8,
    damage: {
      damage_type: {
        index: 'radiant',
        name: 'Radiant',
        url: '/api/damage-types/radiant',
      },
      damage_at_slot_level: {
        8: '12d6',
      },
    },
    dc: {
      dc_type: {
        index: 'con',
        name: 'CON',
        url: '/api/ability-scores/con',
      },
      dc_success: 'half',
      desc: 'On failure, the creature is also blinded for 1 minute.',
    },
    area_of_effect: {
      type: 'cylinder',
      size: 60,
    },
  },
];

export default spellsLVL8;
